exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-slide-upload[data-v-b11494f6]{margin-bottom:20px}.editor-slide-upload .el-upload--picture-card[data-v-b11494f6]{width:100%}", ""]);

// exports
